export default __webpack_public_path__ + "static/media/crazy6-best-practices.8d589c62.pdf";